import * as React from 'react';
import InputRange from 'react-input-range';
import { Row, Col, Label, Button } from 'reactstrap';
import { WrappedSwitch } from '../../../../share/components/Switch/Switch';
import { Form } from '../../../../share/components/Form/Form';
import { IProvider } from '../../../../share/types/provider';
import { IAgency } from 'src/share/types/agency';
import ReactMultiTextarea from '../../../../packages/react-multi-textarea/ReactMultiTextarea';
import "react-input-range/lib/css/index.css"

export interface IProvidersFormProps {
  provider: IProvider;
  logo: string;
  setValue: (providerId: string, path: string, value: any) => void;
  update: (providerId) => void;
  disabled: boolean;
  agencies: IAgency[];
};
export class ProvidersForm extends React.Component<IProvidersFormProps, any> {
  constructor(props: IProvidersFormProps) {
    super(props);
  }
  public onRangeChange(e, providerId) {
    this.props.setValue(providerId, 'threshold', e)
  }
  public onSwitchChange(e, providerId) {
    this.props.setValue(providerId, 'checked', e)
  }
  public render() {
    const { name, providerId, checked, threshold, receivers, disabledAgencies, withoutReceivers } = this.props.provider;
    return (
      <Form disableOnEnter={true} onSubmit={() => this.props.update(this.props.provider)}>
        <Row className="provider-form white-background">
          <Col md={5}>
            <div className="logo">
              <img src={this.props.logo} alt={name} />
            </div>
            <Label className="input-label">Disabled Matches Agencies</Label>
            <ReactMultiTextarea
              key={`${this.props.provider.providerId}-area`}
              elements={disabledAgencies}
              isEmailElement={false}
              dropdownKeys={{ key: 'code', value: 'name' }}
              autoCompleteValues={this.props.agencies}
              onChange={(data) => this.props.setValue(providerId, 'disabledAgencies', data)}
              getLabel={(element: string, index: number, removeElement: (index: number) => void) => {
                const agencyInfo = this.props.agencies.find(agency => agency.code === element);
                return (
                  <div data-tag={true} key={index}>
                    {agencyInfo ? agencyInfo.name : 'No existent agency'}
                    <span data-tag-handle={true} onClick={(e) => {
                      e.stopPropagation();
                      removeElement(index)
                    }}>
                      ×
                    </span>
                  </div>
                );
              }} />
          </Col>
          <Col md={2} />
          <Col md={5} className="mt-5">
            <Label className="input-label">Status</Label>
            <WrappedSwitch disabled={this.props.disabled} id={`switch-${providerId}`} className="wswitch" md={12}
              checked={checked}
              onChange={(e) => this.onSwitchChange(e, providerId)}
              labelText={checked ? 'Active' : 'Disabled'}
            />
            { threshold && 
              <>
                <Label className="input-label m-b-md">Accuracy Threshold</Label>
                <InputRange
                  key={`range-${providerId}`}
                  disabled={!checked || this.props.disabled}
                  value={threshold}
                  onChange={(e) => this.onRangeChange(e, providerId)}
                  formatLabel={value => `${value}%`} maxValue={99} minValue={20} step={5}
                />
              </>
            }
            { withoutReceivers ||
              <>
                <Label className="input-label">Send matches to</Label>
                <ReactMultiTextarea
                  key={`${this.props.provider.providerId}-email`}
                  elements={receivers || []}
                  isEmailElement={true}
                  dropdownKeys={{ key: '', value: '' }}
                  autoCompleteValues={this.props.agencies}
                  onChange={(data) => this.props.setValue(providerId, 'receivers', data)}
                  getLabel={(email: string, index: number, removeElement: (index: number) => void) => {
                    return (
                      <div data-tag={true} key={index}>
                        {email}
                        <span data-tag-handle={true} onClick={(e) => {
                          e.preventDefault();
                          removeElement(index)
                        }}>
                          ×
                      </span>
                      </div>
                    );
                  }}
                />
            </>
          }
          <Button type="submit" className="btn-blue float-right">Save</Button>
          </Col>
        </Row>
      </Form>
    );
  }
}
